module.exports = __webpack_public_path__ + "static/media/skeleton-loading.e2bad709.png";